import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PopupGenericComponent } from './popup-generic/popup-generic.component';
import {DxFileUploaderModule, DxPopupModule, DxScrollViewModule} from "devextreme-angular";
import {MatIconModule} from "@angular/material/icon";


@NgModule({
    declarations: [
        PopupGenericComponent,
    ],
   exports: [
      PopupGenericComponent,
   ],
    imports: [
        CommonModule,
        DxPopupModule,
        DxScrollViewModule,
        DxFileUploaderModule,
        MatIconModule,
    ]
})
export class DialogComponentsModule { }

